import script from "./TaskProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskProgress.vue?vue&type=script&setup=true&lang=js"

import "./TaskProgress.vue?vue&type=style&index=0&id=dc120f74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc120f74"]])

export default __exports__